import React from 'react'
import { Typography, withStyles } from '@material-ui/core'
import styles from './styles'

const ShareViewHeader = props => {
  const { classes, view } = props
  const handleHeaderMessage = () => {
    switch (view) {
      case 'share-collection':
        return 'Collection URL'
      case 'embed-collection':
        return 'Embed on a website'
      case 'share-course':
        return 'Share this mini-course'
      case 'embed-course':
        return 'Embed on a website'
      case 'iframe-course':
        return 'iFrame Code'
      case 'pdf-course':
        return 'Download as PDF'
      case 'scorm-course':
        return 'Download SCORM Package'
      default:
        return 'Share Collection'
    }
  }
  const header = handleHeaderMessage()
  const subHeader =
    header === 'Collection URL'
      ? 'Get link to share your collection.'
      : 'You can embed the collection on your website with JavaScript code.'
  return (
    <div className={classes.customDomain__root}>
      <div className={classes.customDomain__headerWithIcon}>
        <Typography
          fontSize={'18px'}
          fontWeight={500}
          fontFamily={'Inter'}
          className={classes.customDomain__header}
        >
          {header}
        </Typography>
        <Typography
          fontSize={'14px'}
          fontWeight={400}
          fontFamily={'Inter'}
          style={{
            color: '#838D98',
          }}
        >
          {subHeader}
        </Typography>
      </div>
    </div>
  )
}

export default withStyles(styles)(ShareViewHeader)
